<template>
  <div class="results__list">
    <div v-if="isTab2">
      <div v-if="supplierCount">
        <div v-if="showResultsCountText">
          <div v-if="supplierResultsShowing < suppliers.length">
            <p class="p-large">
              Showing <strong>{{ supplierResultsShowing }}</strong> out of <strong>{{ suppliers.length }}</strong> results
            </p>
          </div>
          <div v-else>
            <p class="p-large">
              Showing <strong>{{ suppliers.length }}</strong> out of <strong>{{ suppliers.length }}</strong> results
            </p>
          </div>
        </div>
        <div v-for="(supplier, index) in suppliers" :key="supplier.vendorID">
          <div v-if="index < supplierResultsShowing">
            <ResultCard
              :supplierId="supplier.vendorID"
              :isTab2="isTab2"
              :supplierRegions="supplier.vendorRegions"
              :supplierEmailAddress="supplier.vendorEmailAddress"
              :supplierName="supplier.vendorName"
              :supplierPage="supplier.vendorProfile"
              :supplierPhoneNumber="supplier.vendorPhoneNumber"
              :supplierURLPhoneNumber="supplier.vendorURLPhoneNumber"
              :supplierWebsite="supplier.vendorWebsite"
              :supplierWebsiteText="supplier.vendorWebsiteText"
            ></ResultCard>
          </div>
        </div>
        <div v-if="showResultsCountText">
          <div v-if="supplierResultsShowing < suppliers.length">
            <p class="p-large">
              Showing <strong>{{ supplierResultsShowing }}</strong> out of <strong>{{ suppliers.length }}</strong> results
            </p>
          </div>
          <div v-else>
            <p class="p-large">
              Showing <strong>{{ suppliers.length }}</strong> out of <strong>{{ suppliers.length }}</strong> results
            </p>
          </div>
        </div>
        <div v-if="supplierResultsShowing < suppliers.length || suppliers.length > supplierResultsShowing" class="button__wrapper-center">
          <button aria-label="Load more results" class="button button-tertiary" @click="supplierResultsShowing += 20">
            See more
          </button>
        </div>
      </div>
      <div v-else>
        <div v-if="showNoResultsText">
          <div class="results__no-results-wrapper">
            <h6 v-html="noResultsText"></h6>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="providerCount">
        <div v-if="showResultsCountText">
          <div v-if="providerResultsShowing < providers.length">
            <p class="p-large"> Showing <strong>{{ providerResultsShowing }}</strong> out of <strong>{{ providers.length }}</strong> results</p>
          </div>
          <div v-else>
            <p class="p-large"> Showing <strong>{{ providers.length }}</strong> out of <strong>{{ providers.length }}</strong> results</p>
          </div>
        </div>
        <div v-for="(provider, index) in providers" :key="provider.ID">
          <div v-if="index < providerResultsShowing">
            <ResultCard
              :culturalExperience="provider.culturalExperience"
              :providerId="provider.providerAccIdentifier"
              :isTab2="isTab2"
              :firstName="provider.firstName"
              :gender="provider.genderCode"
              :languages="provider.languages"
              :regions="provider.regions"
              :surname="provider.surname"
              :therapistExperience="provider.therapistExperience"
            ></ResultCard>
          </div>
        </div>
        <div v-if="showResultsCountText">
          <div v-if="providerResultsShowing < providers.length">
            <p class="p-large"> Showing <strong>{{ providerResultsShowing }}</strong> out of <strong>{{ providers.length }}</strong> results</p>
          </div>
          <div v-else>
            <p class="p-large"> Showing <strong>{{ providers.length }}</strong> out of <strong>{{ providers.length }}</strong> results</p>
          </div>
        </div>
        <div class="button__wrapper-center" v-if="providerResultsShowing < providers.length || providers.length > providerResultsShowing">
          <button aria-label="Load more results" class="button button-tertiary" @click="providerResultsShowing += 20">
            See more
          </button>
        </div>
      </div>
      <div v-else>
        <div v-if="showNoResultsText">
          <div class="results__no-results-wrapper">
            <h6 v-html="noResultsText"></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import ResultCard from "./ResultCard.vue";

export default Vue.component("ResultsList", {
  props: {
    isTab2: Boolean,
    noResultsText: String,
    providerCount: Number,
    providers: Array,
    resultsExplainerText: String,
    showNoResultsText: Boolean,
    showResultsCountText: Boolean,
    supplierCount: Number,
    suppliers: Array,
  },
  components: {
    ResultCard,
  },
  data: () => {
    return {
      providerResultsShowing: 20,
      supplierResultsShowing: 20,
    };
  },
});
</script>
